

import React, { useRef } from "react";
import closeIcon from "../../../src/assets/images/Icons/close_icon.svg";
import UseBodyScrollLock from "./UseBodyScrollLock";
import { IoMdClose } from "react-icons/io";

function InnerPopup({ onCloseModal, closeButton = true, modalHeader = false, modalTitle = "message", children }) {
    const showModal = true;
    const popref = useRef();

    const handleModalClose = () => {
        onCloseModal()
    }
    const handleOverlayClick = (event) => {
        event.stopPropagation(); // Stop propagation to prevent clicks outside the modal
        onCloseModal()
    };
    UseBodyScrollLock(showModal)
    return (
        <>
            {
                showModal &&
                <>
                    <div className="modal_overlay"> </div>
                    <div className="modal">
                        <div ref={popref}></div>
                        {
                            modalHeader && (<div className="modal_header">
                                {modalTitle ? <p>{modalTitle}</p> : ""}
                                {modalTitle ? <div className="header_bottom_border"></div> : ""}
                            </div>)
                        }
                        {
                            closeButton ? <div className="modal_close" onClick={handleModalClose}>
                               <IoMdClose className="btnclose"/>
                                </div> : ""
                        }

                        <div className="modal_body">
                            {React.Children.map(children, (child) => 
                                React.isValidElement(child) 
                                    ? React.cloneElement(child, { popref }) // Pass onCloseModal as a prop
                                    : child
                            )}
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default InnerPopup